import { SubmissionWizard } from '@/components/submission/SubmissionWizard'

export default function SubmitPage() {
  return <SubmissionWizard />
}
